import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { seguridadDAModulo } from "src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AplicacionModel } from '../../../model/aplicacionModel';
import { AplicacionUserFrontModel } from '../../../model/aplicacionUserFrontModel';
import { AplicacionUserModel } from '../../../model/aplicacionUserModel';
import { ClaveValorModel } from '../../../model/claveValorModel';
import { DataLoginModel } from '../../../model/dataLoginModel';
import { EmployeModel } from '../../../model/employeModel';
import { AplicacionService } from '../../../services/aplicacion.service';
import { AplicacionUserService } from '../../../services/aplicacionUser.service';
import { UsuarioService } from 'src/app/shared-module/admin-seguridad/services/usuario.service';


@Component({
  selector: 'app-aplicacion-usuario',
  templateUrl: './aplicacion-usuario.component.html',
  styleUrls: ['./aplicacion-usuario.component.css']
})
export class AplicacionUsuarioComponent implements OnInit {

  dataUsuario: DataLoginModel;
  mostrarFormulario: boolean = false;
  listaVacia: boolean = false;
  resposiveFull: string;
  seguridadDAModulo: any = {};

  formularioCrear: FormGroup;
  formularioEditar: FormGroup;
  formularioBuscar: FormGroup;
  loading: boolean = false;

  textoBuscar: string;
  columnDefs: any[];
  rowData: AplicacionUserModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  seletedRowData: AplicacionUserModel;
  cmbEmpleado: ClaveValorModel[] = [];
  cmbAplicacion: ClaveValorModel[] = [];

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _aplicacionUser: AplicacionUserService, 
              private _aplicacion: AplicacionService,
              private _usuario: UsuarioService) { }

  ngOnInit() {

    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.seguridadDAModulo = seguridadDAModulo;
    this.resposiveFull = this.seguridadDAModulo.div.resposiveFull;

    this.formularioCrear = this.fb.group({
      cedula: ['',[Validators.required]],
      appId: ['',[Validators.required]],
      userName: ['',[Validators.required, Validators.maxLength(50)]],
    });

    this.formularioEditar = this.fb.group({
      cedula: ['',[Validators.required]],
      appId: ['',[Validators.required]],
      userName: ['',[Validators.required, Validators.maxLength(50)]],
    });

    this.formularioBuscar = this.fb.group({
      userName: ['',[Validators.required]]
    });

    this.cargarGrid();
    //
    this.getAllEmpleado();
    this.getAllAplicacion();
  }

  listarTodos(){
    this.getAllAplicacionRow();
  }

  buscarUsuario(){
    this.loading = true;
    this._aplicacionUser.findByNick(this.formularioBuscar.get('userName').value).subscribe((res:AplicacionUserModel[])=>{
      this.loading = false;
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.mesaage);
    });
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Empleado',
        field: 'empleado',
        filter: true,
        width: 320,
      },
      {
        headerName: 'Aplicación',
        field: 'seAplicacion.appDesc',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Nombre de Usuario',
        field: 'nombre',
        filter: true,
        width: 230,
      },
      {
        headerName: 'Fecha de Registro',
        field: 'fechCrea',
        filter: true,
        width: 210,
      },
      {
        headerName: 'Fecha de Baja',
        field: 'fechBaja',
        filter: true,
        width: 210,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.callEditarAplicacionUser.bind(this),
          label: "Editar",
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.deleteAplicacionUser.bind(this),
          label: "Eliminar",
        }
      },
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllAplicacionRow() {
    this.loading = true;
    this._aplicacionUser.getAllAplicacionUser().subscribe((res:AplicacionUserModel[])=>{
      this.loading = false;
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.mesaage);
    });
  }

  getAllEmpleado(){
    this.cmbEmpleado = [];
    this._aplicacionUser.getAllEmpleado().subscribe((res:EmployeModel[])=>{
      res.forEach((item)=>{
        this.cmbEmpleado.push({clave: item.cedula, valor: item.nombres,other: item.email});
      });
    },(err)=>{
      console.log(err);
      this.cmbEmpleado = [];
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  getAllAplicacion(){
    this.cmbAplicacion = [];
    this._aplicacion.getAllAplicacion().subscribe((res:AplicacionModel[])=>{
      debugger;
      res.forEach((item)=>{
        this.cmbAplicacion.push({clave: item.appId.toString(), valor: item.appDesc});
      });
      console.log(this.cmbAplicacion);
    },(err)=>{
      console.log(err);
      this.cmbAplicacion = [];
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  callModalCrear(event?){
    this.formularioCrear.get('cedula').setValue('');
    this.formularioCrear.get('appId').setValue('');
    this.formularioCrear.get('userName').setValue('');
    document.getElementById('abrirModalCrear').click();
  }

  crearAplicacionByUser(){
    let item : AplicacionUserFrontModel = new AplicacionUserFrontModel();
    item.cedula = this.formularioCrear.get('cedula').value;
    item.appId = Number(this.formularioCrear.get('appId').value);
    item.userName = this.formularioCrear.get('userName').value;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea crear la siguiente Aplicación por Usuario?',
        text: '',
        action: 'Guardar',
        funcion: this._aplicacionUser.createAplicacionUser(item),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllAplicacionRow();
      document.getElementById('cerrarModalCrear').click();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  deleteAplicacionUser({rowData}){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar la siguiente Aplicación por Usuario?',
        text: '',
        action: 'Eliminar',
        funcion: this._aplicacionUser.deleteAplicacionUser(decodeURI(rowData.cedula),Number(rowData.appId)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllAplicacionRow();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callEditarAplicacionUser(event){
    this.seletedRowData = event.rowData;
    debugger;
    this.formularioEditar.get('cedula').setValue(this.seletedRowData.cedula);
    this.formularioEditar.get('appId').setValue(this.seletedRowData.appId.toString());
    this.formularioEditar.get('userName').setValue(this.seletedRowData.nombre);

    document.getElementById('abrirModalEditar').click();
  }
  
  detectUsername(){
    /*console.log(this.formularioCrear.get('cedula').value);
    let obj = this.cmbEmpleado.find((el) => el.clave === this.formularioCrear.get('cedula').value);
    var arry = obj.other.split("@");
    if(arry.length>0){
      console.log(arry[0]);
      if(arry[1] === 'lafabril.com.ec'){
        this.formularioCrear.get('userName').setValue(arry[0]);
      }else{
        this._util.mensajeErroToast('Correo no corporativo: '+obj.other);
        this.formularioCrear.get('userName').setValue('');
      }
    }*/
      this._aplicacionUser.findByUserKosmos(this.formularioCrear.get('cedula').value).subscribe((res)=>{
      console.log(res);
      if(res.login2 !== null)
        this.formularioCrear.get('userName').setValue(res.login2);
      else
        this.formularioCrear.get('userName').setValue(res.login);
    },(err)=>{
      console.log(err);
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });//TESTEAR
    //console.log(obj);
  }

  editarAplicacionByUser(){
    let item : AplicacionUserFrontModel = new AplicacionUserFrontModel();
    item.cedula = this.formularioEditar.get('cedula').value;
    item.appId = Number(this.formularioEditar.get('appId').value);
    item.userName = this.formularioEditar.get('userName').value;
    item.appIdOld = this.seletedRowData.appId;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea crear la siguiente Aplicación por Usuario?',
        text: '',
        action: 'Editar',
        funcion: this._aplicacionUser.updateAplicacionUser(item),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllAplicacionRow();
      this.seletedRowData = new AplicacionUserModel();
      document.getElementById('cerrarModalEditar').click();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
